import { useCallback, useEffect, useState } from 'react';
import { UsageReport, fetchUsage } from '../../../api/accessApi';
import { useAsync } from './shared';

const today = () => new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD in local time

export default function UsageTab() {
  const [date, setDate] = useState(today());
  const [view, setView] = useState<'tool' | 'user'>('tool');
  const [report, setReport] = useState<UsageReport | null>(null);
  const { error, busy, run } = useAsync();

  const load = useCallback(
    () => run(() => fetchUsage(date)).then((r) => r && setReport(r)),
    [run, date],
  );
  useEffect(() => {
    load();
  }, [load]);

  return (
    <section className="panel">
      <h2>Tool usage</h2>
      {error && <p className="acc-error">{error}</p>}
      <div className="acc-form acc-inline">
        <label>
          Date
          <input type="date" value={date} max={today()} onChange={(e) => e.target.value && setDate(e.target.value)} />
        </label>
        <button className="btn" disabled={busy} onClick={load}>
          Refresh
        </button>
      </div>

      <div className="filters">
        <button className="chip" aria-pressed={view === 'tool'} onClick={() => setView('tool')}>
          By tool
        </button>
        <button className="chip" aria-pressed={view === 'user'} onClick={() => setView('user')}>
          By user
        </button>
      </div>

      {view === 'tool' && (
      <div className="acc-scroll">
        <table className="acc-table">
          <thead>
            <tr>
              <th>Tool</th>
              <th>Requests</th>
            </tr>
          </thead>
          <tbody>
            {report?.by_tool.map((t) => (
              <tr key={t.tool_id}>
                <td>{t.tool}</td>
                <td>{t.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {report && report.by_tool.length === 0 && <p className="note">No tool usage on this date.</p>}
      </div>
      )}

      {view === 'user' && (
      <div className="acc-scroll">
        <table className="acc-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Tool</th>
              <th>Requests</th>
            </tr>
          </thead>
          <tbody>
            {report?.items.map((r) => (
              <tr key={`${r.username}-${r.tool_id}`}>
                <td>
                  <b>{r.username}</b>
                  <span>{r.full_name}</span>
                </td>
                <td>{r.tool}</td>
                <td>{r.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {report && report.items.length === 0 && <p className="note">No tool usage on this date.</p>}
      </div>
      )}
    </section>
  );
}
